/*
 * File: parse-rule-function.ts
 * File Created: 2023-12-19 12:50:41
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2026-01-19 13:34:16
 * Modified By: Val Liu <valuis0429@gmail.com>
 * -----
 */

import { IUITagInput } from "./core";
import { VueHolder } from "@root/core/utilities";

let vueHolder: Vue | undefined = undefined;

export function executeRuleFunction(input: IUITagInput) {
    const func = parseRuleFunction(input);
    /// the rule is not a function.
    if (func == undefined) return undefined;

    /// successfully parsed as a function.
    let result: any;
    try {
        result = func(input.inputs.props);
    } catch (e) {
        console.error(`<FunctionExecute> rule <${input.rule}> execution error`, e);
        /// Val todo: response null for execution error.
        return null;
    }

    if (result === undefined) {
        console.error(
            `<FunctionExecute> rule <${input.rule}> should not response undefined.`,
        );
        /// Val todo: response null to replace undefined for now.
        return null;
    }
    return result;
}

export function parseRuleFunction(input: IUITagInput): Function | null {
    let { rule, meta } = input;
    if (rule == null) return null;

    if (!vueHolder) vueHolder = VueHolder();
    const component = input.component ?? vueHolder ?? (vueHolder = VueHolder());

    const lambdaRegex = /^\(/;
    const funcRegex = /^[a-zA-z]/;

    let func: any;
    if (typeof rule === "function") func = rule;
    else if (typeof rule === "string") {
        if (lambdaRegex.test(rule)) {
            /// lambda function
            func = function (this: any, ...args) {
                try {
                    return eval(rule as any).call(this, ...args);
                } catch (e) {
                    console.error(
                        `<parseRuleFunction> parsing rule error on attribute "${meta.attr.name}".`,
                        rule,
                        e,
                    );
                }
            };
        } else if (funcRegex.test(rule)) {
            /// scoped function
            func = component?.[rule];
        }
    }
    return func?.bind(component);
}
